import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { ApiService } from '@angular/synthrone-design/services';
import { MessagesService } from '@angular/synthrone-design/services/messages/messages.service';
import {VariantModel} from '@synthroneApp/models/variant/variant.model';

@Component({
  selector: 'app-component-variant-form',
  templateUrl: './component-variant-form.component.html',
  styleUrls: ['./component-variant-form.component.scss']
})
export class ComponentVariantFormComponent implements OnInit {

  private submitClicked = false;

  public variant: VariantModel;
  public isEdit = false;
  public isSettingUp = true;

  @ViewChild('f') f;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private messagesService: MessagesService,
    protected api: ApiService,
    public dialogRef: MatDialogRef<ComponentVariantFormComponent>,
    public dialog: MatDialog) {}

  ngOnInit() {
    if (this.data.dataId) {
      this.isEdit = true;
    }

    this.variant = {
      name: '',
      slug: ''
    };

    if (this.data.dataId) {
      this.api.makeRequest('api_system_variant_details', {
        id: this.data.dataId
      }, 'crafter').subscribe(
        (result) => {
          this.variant = {
            name: result['name'],
            slug: result['slug']
          };
          this.isSettingUp = false;
        });
    } else {
      this.isSettingUp = false;
    }
  }

  closeWindow = (param = null) => {
    this.dialogRef.close(param);
  }

  submit = () => {
    this.submitFN(this.f.valid);
  }

  submitFN = (isValid: boolean) => {
    this.submitClicked = true;

    const variantParsed = <any>Object.assign({}, this.variant);

    if (this.isEdit) {
        variantParsed.id = this.data.dataId;
    }

    this.data.callback(variantParsed).catch((error: any) => {
      this.submitClicked = false;
      this.messagesService.showSnack(error, 'error');
      return Observable.throw(error)
    }
    ).subscribe((response) => {
      this.closeWindow(response);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/forms/component-variant-form/component-variant-form.component.ts